var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDownThin = function SvgIconArrowDownThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_arrow_down_thin_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_arrow_down_thin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "m10 9.063-3.417 3.416a.73.73 0 0 1-1.062 0 .73.73 0 0 1 .007-1.07l3.951-3.95a.756.756 0 0 1 .525-.208.692.692 0 0 1 .517.208l3.951 3.95a.73.73 0 0 1 .236.528.718.718 0 0 1-.229.521.73.73 0 0 1-1.062 0L10 9.062Z"
  }))));
};
export default SvgIconArrowDownThin;